
const initCustomTestimonials = function(){
  setTimeout(function(){
    let customTestimonials = document.querySelectorAll('.c-t-section');

    customTestimonials.forEach((customTestimonial) => {
      let imagesArray = [];
      customTestimonial.querySelectorAll('.swiper-slide').forEach((slide) => {
        imagesArray.push(`${slide.getAttribute('data-nav-image')}`)
      });
      let selector = `#${customTestimonial.parentElement.id} .c-t-slider`;
      let params = {
        slidesPerView: 1,
        spaceBetween: 0,
        freeMode: false,
        loop: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        scrollbar: {
          el: ".c-t-slider-nav-inner-container .swiper-scrollbar",
          horizontalClass: 'swiper-scrollbar-horizontal',
          hide: false,
        },
        pagination: {
          el: ".c-t-slider-nav-inner-container .swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
              return '<span class="' + className + '">' + `<img loading="lazy" width="150" height="150" sizes="170px" srcset="${window.Branch.functions.returnSrcSet(imagesArray[index])}" src="${imagesArray[index]}"/>` + '</span>';
            },
        }
      };
  
      var customTestimonalSwiper = new Swiper(selector, params);
    })
  }, 2000)
}

window.onload = initCustomTestimonials();
